import { combineReducers } from 'redux';
import * as types from './constants';

const initialState = [];
const items = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CLEAR_ITEMS:
      return [];

    case types.FETCH_ITEMS:
      return [...state, ...payload];

    case types.FETCH_ITEM:
    case types.UPDATE_ITEM:
    case types.ADD_ITEM:
      return state.filter(item => item.id !== payload.id).concat([payload]);

    case types.DELETE_ITEM:
      return state.filter(item => item.id !== payload);

    default:
      return state;
  }
};

const updatedAt = (state = null, { type }) => {
  switch (type) {
    case types.FETCH_ITEMS:
      return Date.now();
    case types.CLEAR_ITEMS:
      return null;
    default:
      return state;
  }
};

const isFetching = (state = false, { type }) => {
  switch (type) {
    case types.CLEAR_ITEMS:
      return true;
    case types.FETCH_ITEMS:
      return false;
    default:
      return state;
  }
};

const reducer = combineReducers({
  items,
  updatedAt,
  isFetching,
});

export default reducer;
